import axios from "../../config/axiosConfig";
import { GET_WHATSAPP_DEVICE_TOKEN, WHATSAPP_DEVICE_TOKEN_REQUEST, WHATSAPP_DEVICE_TOKEN_REQUEST_FAILURE, GET_WHATSAPP_CUSTOMER_CHECK, DISCONNECT_WHATSAPP_DEVICE_TOKEN } from "../types";

export const getWhatsappDeviceScanner = (params) => {
  return async (dispatch, getState) => {
        try {
            dispatch({ type: WHATSAPP_DEVICE_TOKEN_REQUEST });
            return axios.get("/whatsapp-device/getScanner", { params }).then((response) => {
            if (response.data) {
                dispatch({ type: GET_WHATSAPP_DEVICE_TOKEN, payload: response?.data?.qr });
            }
            return response;
            }).catch((error) => {
                console.error(error);
                dispatch({ type: WHATSAPP_DEVICE_TOKEN_REQUEST_FAILURE, error: error.message });
            });
        } catch (error) {
            console.error(error);
            dispatch({ type: WHATSAPP_DEVICE_TOKEN_REQUEST_FAILURE, error: error.message });
            throw error;
        }
    };
};

export const disconnectWhatsappDeviceScanner = (params) => {
  return async (dispatch, getState) => {
        try {
            dispatch({ type: WHATSAPP_DEVICE_TOKEN_REQUEST });
            return axios.get("/whatsapp-device/disconnectScanner", { params }).then((response) => {
            if (response.data) {
                dispatch({ type: DISCONNECT_WHATSAPP_DEVICE_TOKEN, payload: response?.data });
            }
            return response;
            }).catch((error) => {
                console.error(error);
                dispatch({ type: WHATSAPP_DEVICE_TOKEN_REQUEST_FAILURE, error: error.message });
            });
        } catch (error) {
            console.error(error);
            dispatch({ type: WHATSAPP_DEVICE_TOKEN_REQUEST_FAILURE, error: error.message });
            throw error;
        }
    };
};

export const checkWhatsappRegister = () => {
  return async (dispatch, getState) => {
        try {
            const { auth } = getState();
            let params = { customerId: auth?.user?.Customer_Id };
            dispatch({ type: WHATSAPP_DEVICE_TOKEN_REQUEST });
            return axios.get("/whatsapp-device/checkRegister", { params }).then((response) => {
            if (response?.data) {
                console.log('response?.data?.data>>', response?.data?.data);
                
                dispatch({ type: GET_WHATSAPP_CUSTOMER_CHECK, payload: response?.data?.data });
            }
            return response;
            }).catch((error) => {
                console.error(error);
                dispatch({ type: WHATSAPP_DEVICE_TOKEN_REQUEST_FAILURE, error: error.message });
            });
        } catch (error) {
            console.error(error);
            dispatch({ type: WHATSAPP_DEVICE_TOKEN_REQUEST_FAILURE, error: error.message });
            throw error;
        }
    };
};